module.exports = __webpack_public_path__ + "static/media/ic-2.9f02a4ce.svg";